import { useEffect, useState } from 'react';
import { RiErrorWarningLine } from 'react-icons/ri';
import useGetCompanyInfo from '../../../Hooks/useGetCompanyInfo';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../Providers/AuthProvider';
import { toast } from 'react-toastify';
import useCheckLicense from '../../../Hooks/useCheckLicense.ts';
import { Licenses } from '../../../Data/Licenses.ts';

import './ConsentCard.css'
import { useParams } from '../../../Providers/ParamsProvider.jsx';

const ConsentsCard = ({ user, handleEInvoiceConsentClick, isEInvoiceConsent, setShowChangeAgreementsModal, eInvoiceEmail, handleEInvoiceEmailChange }) => {
    const { companyInfoData } = useGetCompanyInfo()
    const { isMobile } = useParams()
    const { t } = useTranslation();
    const { updateConsentForUser } = useAuth();
    const [consentMarketing, setConsentMarketing] = useState(user.marketingAgreement);
    const [consentInfo, setConsentInfo] = useState(user.marketingEmail || user.marketingPhone || user.marketingSms ? true : false);
    const [contactOptions, setContactOptions] = useState({ email: user.marketingEmail, phone: user.marketingPhone, sms: user.marketingSms });
    const [isValidLicense, setIsValidLicense] = useState(useCheckLicense([Licenses.TgInstalacje]))

    /* const handleConsentSave = () => {
        if (user.marketingAgreement !== consentMarketing || user.marketingEmail !== contactOptions.email || user.marketingPhone !== contactOptions.phone || user.marketingSms !== contactOptions.sms) {
            updateConsentForUser(consentMarketing, contactOptions.email, contactOptions.sms, contactOptions.phone)
            toast.success('Zaktualizowano dane')
        }
    } */

    const handleDownloadPolicy = (policy) => {
        let consentLink = ''
        switch (policy) {
            case "terms_and_conditions_of_the_trading_portal":
                consentLink = '/Statements/TG/Regulamin Portalu Transakcyjnego E-Handel.pdf'
                window.open(consentLink, '_blank')

                break;
            case "terms_and_conditions_OWS":
                consentLink = '/Statements/TG/OWS.pdf'
                window.open(consentLink, '_blank')

                break;
        }
    }

    const handleCheckUncheckConsent = (e) => {
        const checked = e.target.checked
        const option = e.target.id
        if (!checked) {
            setShowChangeAgreementsModal(true)
            return
        }
        if (option === "consent-marketing") {
            setConsentMarketing(checked)
            updateConsentForUser(checked, contactOptions.email, contactOptions.sms, contactOptions.phone)
            toast.success('Zaktualizowano dane')
            return
        }
        if (option === 'consent-info') {
            setConsentInfo(checked)
            setContactOptions({ email: checked, phone: checked, sms: checked })
            updateConsentForUser(consentMarketing, checked, checked, checked)
            toast.success('Zaktualizowano dane')
            return
        }
        if (option === 'email') {
            setConsentInfo(checked)
            const updatedOptions = { ...contactOptions, [option]: checked }
            setContactOptions(updatedOptions)
            updateConsentForUser(consentMarketing, checked, contactOptions.sms, contactOptions.phone)
            toast.success('Zaktualizowano dane')
            return
        }
        if (option === 'sms') {
            setConsentInfo(checked)
            const updatedOptions = { ...contactOptions, [option]: checked }
            setContactOptions(updatedOptions)
            updateConsentForUser(consentMarketing, contactOptions.email, checked, contactOptions.phone)
            toast.success('Zaktualizowano dane')
            return
        }
        if (option === 'phone') {
            setConsentInfo(checked)
            const updatedOptions = { ...contactOptions, [option]: checked }
            setContactOptions(updatedOptions)
            updateConsentForUser(consentMarketing, contactOptions.email, contactOptions.sms, checked)
            toast.success('Zaktualizowano dane')
            return
        }
    }

    let eInvoiceSectionVisibilityStyle = user.roles.find(r => r.roleName == 'Administrator') ? '' : 'collapse'

    return (
        <div>
            <div className='row justify-content-center'>
                <div className='col-12 col-xxl-8 mt-2'>
                    <div className='justify-content-center'>
                        <div className='main-container-holder'>
                            <div className='panel-header-title'>{t("expressed_consent")}</div>
                            {(isValidLicense) ? <> <div className="consent-checkbox">
                                <input type="checkbox" id="terms_and_conditions_of_the_trading_portal" className="checkbox-custom"
                                    checked={true}
                                    onChange={(e) => handleCheckUncheckConsent(e)}
                                />
                                <label>
                                    {t("terms_and_conditions_of_the_trading_portal")}
                                    <span className='error-text-color'> *</span>
                                </label>
                                <div className="ms-1">
                                    <label className='app-link m-0 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_of_the_trading_portal')}>
                                        {t("download")}
                                    </label>
                                </div>
                            </div>
                                <div className="consent-checkbox">
                                    <input type="checkbox" id="terms_and_conditions_OWS" className="checkbox-custom"
                                        checked={true}
                                        onChange={(e) => handleCheckUncheckConsent(e)}
                                    />
                                    <label>
                                        {t("terms_and_conditions_OWS")}
                                        <span className='error-text-color'> *</span>
                                    </label>
                                    <div className="ms-1">
                                        <label className='app-link m-0 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_OWS')}>
                                            {t("download")}
                                        </label>
                                    </div>
                                </div>
                            </> : <></>
                            }
                            <div className="consent-checkbox">
                                <input type="checkbox" id="consent-marketing" className="checkbox-custom" checked={consentMarketing} onChange={(e) => handleCheckUncheckConsent(e)} />
                                <label htmlFor="consent-marketing">
                                    {t("consent_marketing1")}{companyInfoData.name}{t("consent_marketing2")}
                                    <span className='error-text-color'> *</span>
                                </label>
                            </div>
                            <div className="consent-checkbox">
                                <input type="checkbox" id="consent-info" className="checkbox-custom" checked={consentInfo} onChange={(e) => handleCheckUncheckConsent(e)} />
                                <label htmlFor="consent-info">
                                    {t("consent_info1")}{companyInfoData.name}{t("consent_info2")}
                                </label>
                            </div>
                            <div className="checkbox-options">
                                <div className="option">
                                    <input type="checkbox" className="checkbox-custom" id="email" checked={contactOptions.email} onChange={(e) => handleCheckUncheckConsent(e)} />
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className="option">
                                    <input type="checkbox" className="checkbox-custom" id="phone" checked={contactOptions.phone} onChange={(e) => handleCheckUncheckConsent(e)} />
                                    <label htmlFor="phone">{t("phone")}</label>
                                </div>
                                <div className="option">
                                    <input type="checkbox" className="checkbox-custom" id="sms" checked={contactOptions.sms} onChange={(e) => handleCheckUncheckConsent(e)} />
                                    <label htmlFor="sms">Sms</label>
                                </div>
                            </div>
                            <div className={`consent-checkbox d-flex align-items-center ${eInvoiceSectionVisibilityStyle}`}>
                                <input type="checkbox" className="checkbox-custom" checked={isEInvoiceConsent} onChange={(e) => handleEInvoiceConsentClick(e)} />
                                <label htmlFor="consent-info">
                                    {t("eInvoice_consent")}
                                </label>
                                {isEInvoiceConsent && <div>
                                    <label className='secondary-text me-3' style={{ fontSize: '16px' }}>{eInvoiceEmail}</label>
                                    <label className='app-link' onClick={handleEInvoiceEmailChange}>Zgłoś zmiane adresu e-mail</label>
                                </div>}
                            </div>
                            <div className='d-flex align-items-center '>
                                <span className='error-text-color'> *</span>
                                <span className='ms-3'>{t("term_required_to_use_platform")}</span>
                            </div>
                            <div className='consent-warning'>
                                <RiErrorWarningLine size={isMobile ? 50 : 15} className='primary-accent-color-text' />
                                <label className='ms-2'>{t("consent_warning")}</label>
                            </div>
                            {/* <button className="btn-app-secondary mt-3" onClick={() => handleConsentSave()}>{t("report_change")}</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConsentsCard;